export default __webpack_public_path__ + "d5563fe7e753b1e657c940e4c37d2c9a.svg";